"use client";

import { useEffect, useState } from "react";

/**
 * Hook for basic bot detection using honeypot fields, interaction tracking, and timing.
 */
export function useBotDetection() {
  const [honeypotWebsite, setHoneypotWebsite] = useState("");
  const [honeypotCompany, setHoneypotCompany] = useState("");
  const [hasInteracted, setHasInteracted] = useState(false);
  const [formRenderTime] = useState<number>(() => Date.now());

  useEffect(() => {
    const handleMouseMove = () => setHasInteracted(true);
    const handleKeyDown = () => setHasInteracted(true);

    window.addEventListener("mousemove", handleMouseMove, { once: true });
    window.addEventListener("keydown", handleKeyDown, { once: true });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const isBot = () => {
    if (honeypotWebsite || honeypotCompany) {
      return "honeypot";
    }

    const submissionTime = Date.now();
    const timeSpent = submissionTime - formRenderTime;
    if (timeSpent < 2000) {
      return "timing";
    }

    if (!hasInteracted) {
      return "interaction";
    }

    return false;
  };

  return {
    honeypotWebsite,
    setHoneypotWebsite,
    honeypotCompany,
    setHoneypotCompany,
    isBot,
    hasInteracted,
    formRenderTime,
  };
}
